

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const stockTransferAtomList = atom({key:'stockTransfer', default:{stock_transfer_info:[],
    warehouse:[]
}});

const stockTransferEditAtom = atom({key:'stockTransferEdit', default:{transfer_main: [],
    transfer_details: []}});





export  const SetStockTransferList = () => useSetRecoilState(stockTransferAtomList);
export  const GetStockTransferList = () => useRecoilValue(stockTransferAtomList);

export  const SetStockTransferEdit = () => useSetRecoilState(stockTransferEditAtom);
export  const GetStockTransferEdit = () => useRecoilValue(stockTransferEditAtom);
export const ResetTransferEdit = ()=> useResetRecoilState(stockTransferEditAtom);









